var map = {
	"./maru_#000000.png": "0936",
	"./maru_#0000ff.png": "c308",
	"./maru_#00ff00.png": "02ea",
	"./maru_#00ffff.png": "9077",
	"./maru_#073763.png": "b9d9",
	"./maru_#0b5394.png": "8691",
	"./maru_#0c343d.png": "f1dc",
	"./maru_#1155cc.png": "3efc",
	"./maru_#134f5c.png": "d223",
	"./maru_#1c4587.png": "2373",
	"./maru_#20124d.png": "792e",
	"./maru_#274e13.png": "016e",
	"./maru_#351c75.png": "3694",
	"./maru_#38761d.png": "4863",
	"./maru_#3c78d8.png": "f919",
	"./maru_#3d85c6.png": "a5e5",
	"./maru_#434343.png": "198d",
	"./maru_#45818e.png": "1044",
	"./maru_#4a86e8.png": "29547",
	"./maru_#4c1130.png": "8bd8",
	"./maru_#5b0f00.png": "a33f",
	"./maru_#660000.png": "cca6",
	"./maru_#666666.png": "7b0a",
	"./maru_#674ea7.png": "c402",
	"./maru_#6aa84f.png": "6ed3c",
	"./maru_#6d9eeb.png": "eca1",
	"./maru_#6fa8dc.png": "e6e5",
	"./maru_#741b47.png": "472c",
	"./maru_#76a5af.png": "a784",
	"./maru_#783f04.png": "cf6b",
	"./maru_#7f6000.png": "bc30",
	"./maru_#85200c.png": "511e",
	"./maru_#8e7cc3.png": "3468",
	"./maru_#93c47d.png": "a3e7",
	"./maru_#980000.png": "0512",
	"./maru_#990000.png": "70879",
	"./maru_#9900ff.png": "a2aa",
	"./maru_#999999.png": "002f",
	"./maru_#9fc5e8.png": "6cef",
	"./maru_#a2c4c9.png": "6a16",
	"./maru_#a4c2f4.png": "adf9",
	"./maru_#a61c00.png": "d285",
	"./maru_#a64d79.png": "6ce4",
	"./maru_#b45f06.png": "4dc9",
	"./maru_#b4a7d6.png": "95fa",
	"./maru_#b6d7a8.png": "0deb",
	"./maru_#b7b7b7.png": "4349",
	"./maru_#bf9000.png": "b939",
	"./maru_#c27ba0.png": "01bc",
	"./maru_#c9daf8.png": "3d4d",
	"./maru_#cc0000.png": "07a7",
	"./maru_#cc4125.png": "afc9",
	"./maru_#cccccc.png": "41a1",
	"./maru_#cfe2f3.png": "35a8",
	"./maru_#d0e0e3.png": "e43b",
	"./maru_#d5a6bd.png": "4b71",
	"./maru_#d9d2e9.png": "fbdd2",
	"./maru_#d9d9d9.png": "9b1c",
	"./maru_#d9ead3.png": "86f3",
	"./maru_#dd7e6b.png": "552b",
	"./maru_#e06666.png": "2b2f",
	"./maru_#e69138.png": "f5b2",
	"./maru_#e6b8af.png": "8132",
	"./maru_#ea9999.png": "f935",
	"./maru_#ead1dc.png": "4db7",
	"./maru_#efefef.png": "b315",
	"./maru_#f1c232.png": "0e90",
	"./maru_#f3f3f3.png": "56c8",
	"./maru_#f4cccc.png": "456c",
	"./maru_#f6b26b.png": "af5f",
	"./maru_#f9cb9c.png": "7064",
	"./maru_#fce5cd.png": "edaf",
	"./maru_#ff0000.png": "3980",
	"./maru_#ff00ff.png": "eda3",
	"./maru_#ff9900.png": "d92d",
	"./maru_#ffd966.png": "d453",
	"./maru_#ffe599.png": "1cd4",
	"./maru_#fff2cc.png": "9409",
	"./maru_#ffff00.png": "8400",
	"./maru_#ffffff.png": "374a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "73ed";